import WRAP from "WRAP-JS";

/*
SKY_FOSTER_LINKS-205の対応.
WRAP.Loader.Imageを上書き
 */
/* eslint-disable */
(function() {
  // 元のloaderオブジェクトをコピー(クロージャ内のloaderにアクセスできないため)
  var loader = {

    _httpRequest: function(url, auth, data, responseType, postfix, timeout, success, error) {
      if ( auth )
        url = auth[0];
      var xhr = new XMLHttpRequest();
      if (xhr) {
        xhr.onreadystatechange = function() {
          if ( xhr.readyState === 4 ) {
            if ( xhr.status === 200) {
              if ( responseType != 'arraybuffer' && responseType != 'blob' ) {
                success(xhr.responseText, xhr.response, xhr.status);
              }
              else {
                success(null, xhr.response, xhr.status);
              }
            }
            // APIGatewayとの通信エラーの場合、エラーページへリダイレクト
            else if ( xhr.status === 403 && WRAP.DH && WRAP.DH.checkApiGatewayUrl && WRAP.DH.checkApiGatewayUrl(xhr.responseURL) ) {
              location.href = WRAP.DH.apiGateway.errorPage;
            }
            else {
              error(xhr.status);
            }
          }
        };
        if ( data ) {
          xhr.open("POST", url+(postfix||""), true);
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
          //xhr.setRequestHeader('Content-Length', data.length);
        }
        else {
          xhr.open("GET", url+(postfix||""), true);
        }
        if ( auth ) {
          xhr.setRequestHeader('Authorization', auth[1])
          xhr.withCredential = true;
        }
        //xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        // APIGatewayとの通信の場合、Headerにトークンを付与
        if ( WRAP.DH && WRAP.DH.getCookie ) {
          var cookie = WRAP.DH.getCookie();
          if( cookie.access_token && cookie.id_token && WRAP.DH.checkApiGatewayUrl(url) ) {
            xhr.setRequestHeader(WRAP.DH.access_token, cookie.access_token);
            xhr.setRequestHeader(WRAP.DH.id_token, cookie.id_token);
          }
        }
        if ( responseType )
          xhr.responseType = responseType;
        if ( WRAP.Data && WRAP.Data._customizer )
          WRAP.Data._customizer(xhr, url);

        if ( timeout ) {
          xhr.ontimeout = function() {
            error(WRAP.Data.Status.REQUEST_TIMEOUT);
          }
          xhr.timeout = timeout*1000;
        }
        xhr.send(data);
        return xhr;
      }
    },

    data: function(url, data, responseType, postfix, timeout, success, error) {
      var cache_busting = getTimeStamp(postfix);
      var auth = url4cors(url);
      if ( auth )
        url = auth[0];
      if (cache_busting) {
        // Cache busting means we try http first
        loader._httpRequest(url, auth, data, responseType, postfix, timeout,
          function(text, response, status) {
            if (WRAP.Storage.add) // If it works, update WRAP.Storage if overriden
              WRAP.Storage.add(url, data, cache_busting, text||response);
            success(text, response, 200);
          },
          function(text) {
            if (WRAP.Storage.get) {
              WRAP.Storage.get(url, data, cache_busting, function(recorded) {
                if (recorded) {
                  if ( responseType != 'arraybuffer' && responseType != 'blob' )
                    success(recorded, null, 200);
                  else
                    success(null, recorded, 200);
                } else {
                  // If nothing in WRAP.Storage, then we return an error
                  error(WRAP.Data.Status.WRAP_STORAGE_ERROR);
                }
              });
            }
            else {
              error(text)
            }
          });
      } else {
        if (!WRAP.Storage.get) { // If no cache busting, WRAP.Storage is used first if defined
          loader._httpRequest(url, auth, data, responseType, postfix, timeout,
            function(text, response) {
              success(text, response, 200);
            },
            error);
        } else {
          WRAP.Storage.get(url, data, cache_busting, function(recorded) {
            if (recorded) {
              if ( responseType != 'arraybuffer' && responseType != 'blob' )
                success(recorded, null, 200);
              else
                success(null, recorded, 200);
              return;
            } else {
              // the data has not been registered
              loader._httpRequest(url, auth, data, responseType, postfix, timeout,
                function(text, response) {
                  WRAP.Storage.add(url, data, cache_busting, text||response); // We know WRAP.Storage is defined here so no additional check is needed
                  success(text, response, 200);
                },
                error);
            }
          });
        }
      }
    },


    image: function(url, data, postfix, crossOrigin, timeout, success, error) {
      var timer;
      var conversion = null;
      var img = new Image();
      if ( crossOrigin )
        img.crossOrigin = crossOrigin;
      img.onload = function() {
        if ( timer )
          clearInterval(timer);
        if ( !conversion && WRAP.Storage.add) { // ・・・add  overriden check!
          var canvas = document.createElement('canvas');
          canvas.width  = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          var base64img = canvas.toDataURL('image/png');
          WRAP.Storage.add(url, null, null, base64img);
        }
        success(img);
      };
      img.onerror = function() {
        if ( timer )
          clearInterval(timer);
        error(WRAP.Data.Status.IMAGE_LOAD_ERROR);
      };

      var auth = url4cors(url);
      if ( auth ) {
        this.data(url, data, 'blob', postfix, timeout,
          function(text, response, status) {
            if ( response ) {
              var bloburl = window.URL || window.webkitURL;
              img.src = conversion = bloburl.createObjectURL(response);
            }
            else {
              error(status);
            }
          },
          function(status) {
            error(status);
          }
        );
        return;
      }

      if ( !WRAP.Storage.get ) {
        img.src = url+(postfix||"");
      }
      else {
        WRAP.Storage.get(url, null, null, function(base64img) {  // get overriden check
          if ( base64img )
            img.src = conversion = base64img;
          else
            img.src = url+(postfix||"");
        })
      }

      if ( timeout ) {
        timer = setTimeout(function() {
          if ( !timer )
            return;
          img.onload = img.onerror = null;
          error(WRAP.Data.Status.REQUEST_TIMEOUT);
        }, timeout*1000);
      }

    },
  }

  // loaderオブジェクトの必要なメソッドを外部から参照できるように準備

  var re4ba = RegExp('(\\w*):(\\w*)@');
  function url4cors(url) {
    var m = url.match(re4ba);
    if (m) {
      var id_pos = url.indexOf('://')+3;
      var pos = url.indexOf(m[0]);
      if ( id_pos == pos ) {
        var id = m[1];
        var pw = m[2];
        var auth = 'Basic ' + window.btoa(id + ':' + pw);
        url = url.replace(m[0], '');
        return [url, auth];
      }
    }
  }

  function padding(v, l) {
    if ( l == void 0 )
      l = 2;
    var t = "" + v;
    while ( t.length < l )
      t = "0" + t;
    return t;
  }

  function postfix(url, cache_busting) {
    var postfixStr = (url.indexOf("?")>=0)?"&":"?";
    if ( WRAP.Data.version )
      postfixStr += "wrap-data="+WRAP.Data.version;
    if ( cache_busting ) {
      if ( typeof cache_busting === "string" && cache_busting !== "") {
        var t = cache_busting;
        var date = new Date();
        function padding(v, l) {
          if ( l == void 0 ) l = 2;
          var t = "" + v;
          while ( t.length < l ) t = "0" + t;
          return t;
        }
        t = t.replace(/YYYY/g, padding(date.getUTCFullYear(),4));
        t = t.replace(/YY/g, padding(date.getUTCFullYear()%100,2));
        t = t.replace(/MM/g, padding(date.getUTCMonth()+1, 2));
        t = t.replace(/DD/g, padding(date.getUTCDate(), 2));
        t = t.replace(/HH/g, padding(date.getUTCHours(), 2));
        t = t.replace(/hh/g, padding(date.getUTCHours(), 2));
        t = t.replace(/mm/g, padding(date.getUTCMinutes(), 2));
        t = t.replace(/ss/g, padding(date.getUTCSeconds(), 2));
        postfixStr += "&t="+t;
      }
      else {
        postfixStr += "&t="+(new Date()).getTime();
      }
    }
    return postfixStr;
  }

  function getTimeStamp(url){
    return url == url.split("t=")[0] ? null : url.split("t=")[1];
  }

  function processError(url, data, status, desc, msg, error) {
    if ( error )
      error(url, status);
    var text = "";
    if ( desc )
      text = msg;
    if ( msg )
      text += (text.length?":":"")+msg;
    WRAP.Loader.error(url, data, status, text);
  }

  // カスタムmakeImageData関数
  function makeImageData(img, modification) {
    var image = { image:img };
    if ( modification ) {
      var canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      /*
      willReadFrequentlyを付与することでgetImageDataがGPUではなくCPUが使われる。
      その結果、性能改善 & Safariでの画像ザラつきがなくなる
      */
      var ctx = canvas.getContext("2d", { willReadFrequently: true });
      ctx.drawImage(img, 0, 0);
      var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      image.canvas = canvas;
      image.ctx = ctx;
      image.imageData = imageData;
    }
    return image;
  }

  // WRAP.Loader.Imageを上書き（内容は変更無し）
  WRAP.Loader.Image = function(opt) {
    var encode = null
    var prefix = opt.subtype && opt.subtype.indexOf('base64');
    if ( prefix == 0 )
      encode = opt.subtype.substr(7);
    var modification = opt.modification === undefined || opt.modification !== false;
    var crossOrigin = opt.crossOrigin || 'anonymous';
    if ( encode ) {
      return loader.data(opt.url, opt.data, 'arraybuffer', postfix(opt.url, opt.cache_busting),
        opt.timeout,
        function(text, response, status) {
          text; status;
          if ( response ) {
            var u8 = new Uint8Array(response);
            var len = u8.byteLength;
            var ba = '';
            for ( var i = 0 ; i < len; i++ )
              ba += String.fromCharCode(u8[i]);
            var b64encoded = btoa(ba);
            var mimetype = encode;
            var img = new Image();
            img.onload = function() {
              var image = makeImageData(img, modification);
              opt.success(image, opt.url);
            }
            img.onerror = function() {
              processError(opt.url, opt.data, WRAP.Data.Status.IMAGE_LOAD_ERROR, opt.desc, "Image Error", opt.error);
            }
            //console.log("load Image "+image_url);
            img.src = "data:"+mimetype+";base64,"+b64encoded;
          }
        },
        function(status) {
          processError(opt.url, opt.data, status, opt.desc, "XMLHttpRequest Error", opt.error);
        }
      )
    }
    else {
      return loader.image(opt.url, opt.data, postfix(opt.url, opt.cache_busting),
        modification?crossOrigin:undefined,
        opt.timeout,
        function(img) {
          var image = makeImageData(img, modification);
          opt.success(image, opt.url);
        },
        function(status) {
          processError(opt.url, opt.data, status, opt.desc, "Image Error", opt.error);
        }
      );
    }
  };
})();
/* eslint-enable */
